import React from 'react';

export const PRIORITY_COLORS = {
    High:   {dot: 'bg-red-500'},
    Medium: {dot: 'bg-amber-500'},
    Low:    {dot: 'bg-green-600'},
};

const DotLabel = ({value}) => {
    const colors = PRIORITY_COLORS[value] ?? {dot: 'bg-tm-gray-400'};

    return (
        <span className="inline-flex items-center gap-1.5">
            <span className={`w-2 h-2 rounded-full shrink-0 ${colors.dot}`} />

            <span className="text-sm font-medium">
                {value}
            </span>
        </span>
    );
};

export default DotLabel;
